// extracted by mini-css-extract-plugin
export default {"wrapper":"post_button___wrapper___da8eeb6b","text":"post_button___text___a8864675"};